var map = {
  "./arrow_down.svg": "54041",
  "./bbc_motion_gallery.svg": "66652",
  "./bloomberg_tv.svg": "23703",
  "./checkmark.svg": "8210",
  "./epidemic_logo.svg": "15093",
  "./gi_custom_content.svg": "76625",
  "./gi_the_download_web_series.svg": "19487",
  "./gi_visual_gps.svg": "29895",
  "./itn.svg": "67386",
  "./lighthouse_films.svg": "39171",
  "./logo_creativeinsights.svg": "92421",
  "./nbc_logo_long.svg": "91225",
  "./smithsonian.svg": "80560",
  "./sony_pictures.svg": "77540",
  "./sony_pictures_full.svg": "22824",
  "./triple_scoop_logo.svg": "27192",
  "./universal.svg": "28466",
  "./vice.svg": "72496",
  "./visualgps_insights.svg": "43123"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 15484;
